import React from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import StakeIcon from '../images/stake-image-blue-dual-ring.svg'

export const getUrlParameters = (redirectUrl, sParam) => {
    const sURLQueryString = redirectUrl.split('?');
    const sURLVariables = sURLQueryString[1].split('&')
    for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            if (sParameterName[1].indexOf("#") > -1) {
                var code = sParameterName[1].split('#');
                console.log('code', code)
                return code[0];
            }
            return sParameterName[1];
        }
    }
  }
  
  export const generateRandomString = function(length) {
      let text = '';
      const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    
      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
  };

  export const isEmail = (email) => {
      const emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (email.match(emailRegEx)) {
          return true;
      } else {
          return false;
      }
  }



  export const checkGameStart = (startDateTime) => {
    //cutoff for odds updates is 1 hour prior to start
    const msHour = 300000;
    var now = new Date();
    var start = Date.parse(startDateTime);
    var cutoff = start - msHour;
    return (Date.parse(now) > cutoff)
  }

  export const spreadPrediction = (game, odds, awayTeamScore, homeTeamScore) => {
    if (!odds) {
      return;
    }
    const { homeTeam, awayTeam } = game
    awayTeamScore = parseFloat(awayTeamScore)
    homeTeamScore = parseFloat(homeTeamScore)
    const {spread } = odds

    let oddsPredictionText = ''
    if (spread > 0) { // away team favored; e.g. spread = 3.5
      if ((awayTeamScore - homeTeamScore) < spread) { // user predicted home team to cover
        oddsPredictionText = `${homeTeam.code} +${spread}`
      } else if ((awayTeamScore - homeTeamScore) === spread) {
        oddsPredictionText = 'PUSH'
      } else {
        oddsPredictionText = `${awayTeam.code} -${spread}`
      }
    }
    if (spread <= 0) { // home team favored; e.g. spread = -3.5
      if ((awayTeamScore - homeTeamScore) > spread) { //user predicted away team to cover
        oddsPredictionText = `${awayTeam.code} +${spread * -1}`
      } else if ((awayTeamScore - homeTeamScore) === spread) {            
        console.log(`predicted spread: ${awayTeamScore - homeTeamScore} odds spread: ${spread}`)
        oddsPredictionText = 'PUSH'
      } else {
        oddsPredictionText = `${homeTeam.code} ${spread}`
      }
    }
    return oddsPredictionText;

  }
  export const totalPrediction = (game, odds, awayTeamScore, homeTeamScore) => {
    if (!odds) {
      return;
    }
    awayTeamScore = parseFloat(awayTeamScore)
    homeTeamScore = parseFloat(homeTeamScore)
    const {total} = odds
      if ((awayTeamScore + homeTeamScore) > total) { //user predicted game to go over
        return `O${total}`
      } else if ((awayTeamScore + homeTeamScore) === total) {
        return `PUSH`
      } else {
        return `U${total}`
      }
  }

const imageIsLoaded = (e) => {
    document.getElementById('avatarImage').setAttribute('src', e.target.result)
}

export const handleImageChange = (event) => {
  event.preventDefault()
  const image = event.target.files[0]
  console.log('image', image)
  let formData = new FormData()
  formData.append('image', image, image.name);
  let fileReader = new FileReader();
  fileReader.readAsDataURL(image)
  fileReader.onload = imageIsLoaded
  localStorage.setItem('avatar', formData)
}
export const handleEditPicture = () => {
    const fileInput = document.getElementById('imageInput')
    fileInput.click();
}

export const antIcon = (props) => {
    console.log('props', props)
    return (<LoadingOutlined style={{ fontSize: 24 }} spin />)
}

export const straightUpPredictionWager = (game, prediction, wagerObj) => {
  if (wagerObj && wagerObj.wager) {
     let wager = wagerObj.wager;
     let selection = wager.participantId === game.homeTeam.participantId ? game.homeTeam.code : game.awayTeam.code;
     return `${selection} ML`;
  }
  if (!prediction || !prediction.awayTeam || !prediction.homeTeam) return '';
  return prediction.awayTeam.score === prediction.homeTeam.score 
    ? 'TIE' 
    : (prediction.awayTeam.score > prediction.homeTeam.score 
       ? `${game.awayTeam.code}${wagerObj && ` ML`}` 
       : `${game.homeTeam.code}${wagerObj && ` ML`}`);
}

export const spreadPredictionWager = (game, prediction, wagerObj) => {
  const odds = prediction && prediction.odds ? prediction.odds : game.odds;
  if (!odds) return '';
  if (odds.spread === 0) {
    if (!prediction || !prediction.awayTeam || !prediction.homeTeam) return '';
    return prediction.homeTeam.score > prediction.awayTeam.score ? `${game.homeTeam.code} PK` : `${game.awayTeam.code} PK`;
  }
  
  if (wagerObj && wagerObj.wager && wagerObj.wager.spreadTotal !== undefined) {
    let selection = wagerObj.wager.participantId === game.homeTeam.participantId ? game.homeTeam.code : game.awayTeam.code;
    return `${selection} ${wagerObj.wager.spreadTotal > 0 ? '+' : ''}${wagerObj.wager.spreadTotal}`;
  }

  if (!prediction || !prediction.awayTeam || !prediction.homeTeam) return '';
  return ((prediction.homeTeam.score + odds.spread) < prediction.awayTeam.score)
    ? (odds.spread < 0 ? `${game.awayTeam.code} +${odds.spread * -1}` : `${game.awayTeam.code} ${odds.spread * -1}`)
    : (odds.spread > 0 ? `${game.homeTeam.code} +${odds.spread}` : `${game.homeTeam.code} ${odds.spread}`);
}

export const totalPredictionWager = (game, prediction, wagerObj) => {
  const odds = prediction && prediction.odds ? prediction.odds : game.odds;
  if (!odds) return '';
  const totalVal = (wagerObj && wagerObj.wager && wagerObj.wager.spreadTotal !== undefined) ? wagerObj.wager.spreadTotal : odds.total;
  if (!prediction || !prediction.awayTeam || !prediction.homeTeam) return '';
  const totalScore = parseFloat(prediction.awayTeam.score) + parseFloat(prediction.homeTeam.score);
  return totalScore === odds.total ? 'PUSH' : (totalScore > odds.total ? `OVER ${totalVal}` : `UNDER ${totalVal}`);
}

export const getTeaserOptions = (game, prediction) => {
  const baseSpread = Number(prediction?.odds?.spread ?? game?.odds?.spread ?? 0)
  const favoriteTeamCode = baseSpread < 0 ? game?.homeTeam?.code : game?.awayTeam?.code
  const underdogTeamCode = baseSpread < 0 ? game?.awayTeam?.code : game?.homeTeam?.code
  const formatLine = (value) => `${value > 0 ? '+' : ''}${value}`
  const favoriteLine = baseSpread < 0 ? baseSpread + 6 : (baseSpread * -1) + 6
  const underdogLine = Math.abs(baseSpread) + 6

  return [
    {
      id: `${game?.gameId ?? 'game'}-${favoriteTeamCode}-teaser-${formatLine(favoriteLine)}`,
      teamCode: favoriteTeamCode,
      label: `${favoriteTeamCode} ${formatLine(favoriteLine)}`,
      originalLine: baseSpread,
      teasedLine: favoriteLine,
    },
    {
      id: `${game?.gameId ?? 'game'}-${underdogTeamCode}-teaser-${formatLine(underdogLine)}`,
      teamCode: underdogTeamCode,
      label: `${underdogTeamCode} ${formatLine(underdogLine)}`,
      originalLine: baseSpread * -1,
      teasedLine: underdogLine,
    },
  ].filter((option) => option.teamCode)
}